import { render, staticRenderFns } from "./FactoryUec.vue?vue&type=template&id=f22ca9c4"
import script from "./FactoryUec.vue?vue&type=script&lang=ts"
export * from "./FactoryUec.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports